import { default as sides, orbit } from 'src/constants/sides'

export const views = [...sides, orbit] as const
